import { ModuleWithProviders, NgModule } from '@angular/core';
import { Ng2TelInputDirective } from './ng2-tel-input.directive';

@NgModule({
	declarations: [Ng2TelInputDirective],
	exports: [Ng2TelInputDirective],
})
export class Ng2TelInputModule {
	static forRoot(): ModuleWithProviders<unknown> {
		return {
			ngModule: Ng2TelInputModule,
			providers: [],
		};
	}
}
